import styled from 'styled-components';

export const LinkWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: center;

  > button {
    background-color: ${({ theme }) => theme.color.s1} !important;
    color: ${({ theme }) => theme.color.ui7};
    &:hover {
      color: ${({ theme }) => theme.color.ui6} !important;
    }
  }
`;
